const Config = {
  ENV: process.env.REACT_APP_ENV,
  API_URL: process.env.REACT_APP_API_URL,
  KABIN_APP_API_URL: process.env.REACT_APP_KABIN_PAD_API_URL,
};

export default Config;
